import populatePublicFolderOutlookFavoriteStore from './actions/populatePublicFolderOutlookFavoriteStore';
import populatePublicFolderFavoriteStoreV1 from './actions/populatePublicFolderFavoriteStoreV1';

import { createLazyComponent, LazyModule, registerLazyOrchestrator } from 'owa-bundling';
import loadFavorites from 'owa-favorites/lib/actions/loadFavorites';

// Import mutators
import './mutators/addPublicFolderToStoreMutator';
import './mutators/removeFavoriteFromPublicFolderStoreMutator';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "PublicFolderFavorite" */ './lazyIndex')
);

// Register lazy orchestrators
registerLazyOrchestrator(loadFavorites, lazyModule, m => m.loadPublicFolderFavoritesOchestrator);
registerLazyOrchestrator(
    populatePublicFolderOutlookFavoriteStore,
    lazyModule,
    m => m.populatePublicFolderOutlookFavoriteStoreOrchestrator
);
registerLazyOrchestrator(
    populatePublicFolderFavoriteStoreV1,
    lazyModule,
    m => m.populatePublicFolderFavoriteStoreV1Orchestrator
);

// Create lazy components
export const PostedToLine = createLazyComponent(lazyModule, m => m.PostedToLine);

export { default as addPublicFolderToStore } from './actions/addPublicFolderToStore';
export {
    default as removeFavoriteFromPublicFolderStore,
} from './actions/removeFavoriteFromPublicFolderStore';
export { default as PublicFolderRequestInit } from './services/utils/PublicFolderRequestInit';
export { default as getPublicFolders } from './services/getPublicFolders';
export {
    default as publicFolderFavoriteStore,
    PublicFolderStore,
} from './store/publicFolderFavoriteStore';
